import * as selfUpdate from './selfUpdate.ts';
export { installPnpmToTools } from './installPnpmToTools.ts';

export { selfUpdate };
